import {Component, OnInit, ViewChild} from '@angular/core';
import {AppInboxService} from "../../../services/appInbox/app-inbox.service";
import {InboxNotification} from "../../../types/interfaces";
import {MyGreenCountry} from "../../../services/mygreencountry/my-greencountry";
import {LocaleService} from "../../../services/mygreencountry/locale.service";

@Component({
    selector: 'app-app-inbox',
    templateUrl: './app-inbox.component.html',
    styleUrls: ['./app-inbox.component.scss'],
})
export class AppInboxComponent implements OnInit {
    @ViewChild('popover') popover: any;
    isPopoverInbox = false;
    activeLanguage : string = 'uk';
    unreadNotifications$ = this.appInboxService.getUnreadNotifications();
    availableNotifications: InboxNotification[]|null = null;
    userToken:null|string = null;

    constructor(
        private appInboxService: AppInboxService,
        public myGcService: MyGreenCountry,
        private localeService: LocaleService,
    ) {

        this.activeLanguage = this.localeService.getLanguage();

        this.appInboxService.getUserTokenAppInboxAsObservable().subscribe(token=>{
            this.userToken = token;
        })
    }

    ngOnInit() {
    }


    presentPopover(e: Event) {
        this.getArticles();
        this.popover.event = e;
    }


    openNotificationUrl(id:string, link: string | undefined, notice:any) {
        if (link){
            this.myGcService.openUrl(link);
        }

        notice.status = 'OPEN';

        this.appInboxService.setArticleAsOpen(id)
    }

    formatDate(timestamp: number): string {
        let date = new Date(timestamp);

        return date.toLocaleDateString(this.activeLanguage, { day: 'numeric', month: 'long', year: 'numeric' });
    }

    getArticles() {
        if (this.userToken && this.userToken !=''){
            let response = this.appInboxService.getArticles().subscribe({
                next: (articles) => {
                        console.log('Articles:', articles);
                        this.availableNotifications = articles.list;
                        this.availableNotifications.forEach((notice) => {

                            if (notice.createDate) {

                                notice.createdDateString = this.formatDate(notice.createDate);
                            } else {
                                notice.createdDateString = "No Date Available";
                            }
                        });

                },
                error: (err) => {
                    console.error('Error:', err);
                    this.availableNotifications = []
                },
                complete: () => {
                    console.log('Request completed.');
                    this.isPopoverInbox = true;
                }
            });
        }else{
            this.availableNotifications = []
            this.isPopoverInbox = true;
        }
    }

}
